import React, { useEffect, useState } from "react";
import Loader from "../../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server from "../../../api/server";

const BlogCategoriesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "جميع الانواع",
				breadcrumb: "الانواع",
				button: {
					show: true,
					text: "اضافة نوع جديدة",
					link: "/blogs/categories/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/categories");
			setData(pageData.data.data.categories);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/categories/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	useEffect(() => {
		onStart();
	}, []);
	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data.map(post => (
						<div className="col-md-3" key={post.id}>
							<div className="serviceItem">
								<button onClick={() => handleDelete(post.id)}>
									<i className="fas fa-trash"></i>
								</button>
								<Link to={`/blogs/categories/show/${post.id}`}>
									<h1>{post.title?.ar ?? ""}</h1>
								</Link>
							</div>
						</div>
					))}
				</div>
			</section>
		</section>
	);
};

export default BlogCategoriesIndex;
